/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconElevator = createReactComponent("elevator", "IconElevator", [
  [
    "path",
    {
      d: "M5 4m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M10 10l2 -2l2 2", key: "svg-1" }],
  ["path", { d: "M10 14l2 2l2 -2", key: "svg-2" }]
]);

export { IconElevator as default };
//# sourceMappingURL=IconElevator.js.map
